import { MobileNextServiceBanner } from "@jesus-central-church/ui";
import { getNextServiceEvent } from "../../lib/events";
import { SbNextServiceBanner } from "../..";

export async function NextServiceBannerComponent({ blok, pageData }: { blok: SbNextServiceBanner, pageData: { locale: string } }) {
    const nextService = await getNextServiceEvent(pageData.locale);

    if (!nextService) {
        return null;
    }

    if (!blok.onlyShowOnMobile) {
        return <MobileNextServiceBanner serviceDate={new Date(nextService.startDateTime)} title={nextService.title} location={nextService.location} />;
    }

    return <div className="md:hidden"><MobileNextServiceBanner serviceDate={new Date(nextService.startDateTime)} title={nextService.title} location={nextService.location} /></div>;
}